export default function getResource(label) {
    const resources = {
        freeReturns: 'Retours gratuits',
        subHeader: 'Retournez des articles GRATUITEMENT',
        canadaText: 'Tout article neuf ou légèrement utilisé peut être retourné en personne à n’importe quel magasin Sephora au Canada ou par la poste avec notre étiquette de retour prépayée. Aucuns frais de manutention ou d’expédition de retour ne s’appliquent. Les commandes Achetez en ligne, ramassez en magasin et Instacart ne peuvent être retournées qu’en magasin. Les cartes-cadeaux et les appareils intimes ne peuvent être retournés.',
        gotIt: 'Compris',
        learnMore: 'En savoir plus',
        assuranceSubHeader: 'Profitez de 30 jours de retours GRATUITS et faciles, en ligne ou en magasin',
        assuranceBody: 'Si, pour quelque raison que ce soit, vous n’êtes pas entièrement satisfait d’un achat ou d’un cadeau Sephora, vous pouvez retourner vos produits neufs ou légèrement utilisés dans les 30 jours suivant l’achat pour obtenir un remboursement complet selon votre mode de paiement original.',
        seeReturnsExchanges: 'Consultez la section Retours et échanges pour plus d’informations'
    };

    return resources[label];
}
